@if (costs) {
  <div class="invest-wrapper" [formGroup]="form" [class.loading-overlay]="loading">
    @if(anfrage.showCostChangeHint) {
      <div class="callout warning change-hint" [innerHTML]="textkeyPrefix + '.changehint' | translate"></div>
    }

    @for (measure of costs.positions; track measure.name) {
      <div class="invest-row">
        <span [innerHTML]="textkeyPrefix + '.' + measure.name | translate" id="cost_{{measure.name}}"></span>
        @if (editMode) {
          <span [class.edit]="editMode">
            <input
              type="number"
              [class.error]="form.get(measure.name)?.touched && form.get(measure.name)?.invalid"
              step="1"
              [formControlName]="measure.name"
              (blur)="onInputBlur()"
              (keydown.enter)="onInputBlur()"
              [attr.aria-labelledby]="'cost_' + measure.name"
            >
            <span class="unit">€</span>
            @if(form.get(measure.name)?.touched && form.get(measure.name)?.invalid) {
              <div role="alert" class="error-message show" [innerHTML]="textkeyPrefix + '.error' | translate"></div>
            }
          </span>
        } @else {
          <span>
            {{ form.get(measure.name)?.value | number: '1.0-0' }} €
            <span aria-hidden="true" [style.visibility]="modifiedFields.has(measure.name)? 'visible' : 'hidden'"> *</span>
          </span>
        }
      </div>
    }
    @if (!this.editMode && this.modifiedFields.size > 0) {
      <div class="invest-row hint" [innerHTML]="textkeyPrefix + '.changed' | translate"></div>
    }
    <div class="invest-row sum">
      <span [innerHTML]="textkeyPrefix + '.gesamt' | translate"></span>
      <span>
        {{ costs.overall.sum | number: '1.0-0' }} €
      </span>
    </div>
    @if (!editMode) {
      <div class="invest-row edit-buttons">
        @if(this.modifiedFields.size > 0) {
          <button class="button secondary" (click)="resetValues()">
            <i class="icon-return"></i>
            {{ textkeyPrefix + '.reset' | translate }}
          </button>
        }
        <button class="button secondary" (click)="toggleEditMode()">
        <i class="icon-edit-3"></i>
          {{ textkeyPrefix + '.edit' | translate }}
      </button>
      </div>
    }
    @if (editMode) {
      <div class="invest-row edit-buttons">
        <button class="button secondary" (click)="resetValues()">
          <i class="icon-return"></i>
          {{ textkeyPrefix + '.reset' | translate }}
        </button>
        <button class="button primary" (click)="saveChanges(true)">{{ textkeyPrefix + '.save' | translate }}</button>
      </div>
    }
  </div>
}
